// utils/loadGzipJson.js
import { ungzip } from 'pako';
/**
 * Fetches a .gz JSON from S3 (via a presigned URL), decompresses, and parses it.
 * Works with DecompressionStream('gzip') when available; falls back to pako.
 *
 * @param {string} presignedUrl - The S3 presigned GET URL to your .json.gz
 * @returns {Promise<any>} Parsed JSON
 */
export async function loadGzipJsonFromS3(presignedUrl) {
    const s3Config = {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }}
  const res = await fetch(presignedUrl, s3Config);
     console.log("S3 GET response status:", res);

  if (!res.status || res.status < 200 || res.status >= 300) throw new Error(`S3 GET failed: ${res.status} ${res.statusText}`);
    const res_data =res
    const blob = await res_data.blob();

    const blobToBytes = async (b) => new Uint8Array(await b.arrayBuffer());

  // Prefer a simple feature-detect without globalThis
  if (typeof DecompressionStream !== 'undefined') {
    try {
      const ds = new DecompressionStream('gzip');
      const decompressed = blob.stream().pipeThrough(ds);
      const outBlob = await new Response(decompressed).blob();
      const bytes = await blobToBytes(outBlob);
      const text = new TextDecoder().decode(bytes);
    //   console.log("Decompressed text:", text); // Log first 100 chars for debugging
      return JSON.parse(text);
    } catch {
        console.warn("DecompressionStream failed, falling back to pako");
      // fall through to pako
    }
  }

  // Fallback: pako
  const raw = await blobToBytes(blob);
  let unzipped;
  try {
    unzipped = ungzip(raw);
  } catch {
    // If server/browser already decompressed it
    unzipped = raw;
  }

  const text = new TextDecoder().decode(unzipped);
  return JSON.parse(text);
}